import { render, staticRenderFns } from "./gs-button-icon.vue?vue&type=template&id=6ad4b04e&scoped=true&"
import script from "./gs-button-icon.vue?vue&type=script&lang=ts&"
export * from "./gs-button-icon.vue?vue&type=script&lang=ts&"
import style0 from "./gs-button-icon.vue?vue&type=style&index=0&id=6ad4b04e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4b04e",
  null
  
)

export default component.exports